import * as Tone from "tone";
import { midiToFrequency } from "../utils/midiToFrequency";

export interface TrackVoice {
  attackAt(midi: number, time: number, velocity?: number): void;
  releaseAt(midi: number, time: number): void;
  releaseAllNow(): void;
  setRelease(seconds: number): void;
  connect(dest: Tone.ToneAudioNode): void;
  dispose(): void;
}

export function createMonoSine(): TrackVoice {
  const synth = new Tone.Synth({
    oscillator: { type: "sine" },
    envelope: { attack: 0.01, decay: 0.08, sustain: 0.7, release: 0.25 },
  });
  return {
    attackAt(midi, time, velocity) {
      synth.triggerAttack(midiToFrequency(midi), time, velocity);
    },
    releaseAt(_midi, time) {
      synth.triggerRelease(time);
    },
    releaseAllNow() {
      synth.triggerRelease();
    },
    setRelease(seconds) {
      synth.envelope.release = seconds;
    },
    connect: (d) => {
      synth.connect(d);
    },
    dispose: () => synth.dispose(),
  };
}

export function createPolySine(): TrackVoice {
  const synth = new Tone.PolySynth(Tone.Synth, {
    oscillator: { type: "sine" },
    envelope: { attack: 0.01, decay: 0.08, sustain: 0.7, release: 0.25 },
  });
  synth.maxPolyphony = 6;
  return {
    attackAt(midi, time, velocity) {
      synth.triggerAttack(midiToFrequency(midi), time, velocity);
    },
    releaseAt(midi, time) {
      synth.triggerRelease(midiToFrequency(midi), time);
    },
    releaseAllNow() {
      synth.releaseAll();
    },
    setRelease(seconds) {
      synth.set({ envelope: { release: seconds } });
    },
    connect: (d) => {
      synth.connect(d);
    },
    dispose: () => synth.dispose(),
  };
}
